import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { enrollInCourse } from '../services/courseService';
import { notifySuccess, notifyError, notifyWarning, notifyInfo } from '../utils/notifications';

export function useEnrollCourse() {
  const navigate = useNavigate();
  const { isAuthenticated, isStudent, isTeacher, getAuthHeaders } = useAuth();
  const [enrollingId, setEnrollingId] = useState(null);

  const enroll = async (courseId, courseTitle, onSuccess) => {
    if (!isAuthenticated) {
      notifyInfo('Please login to enroll in a course.');
      navigate('/login');
      return false;
    }
    if (isTeacher) {
      notifyWarning('Teachers cannot enroll in courses. Please register a separate student account to enroll.');
      return false;
    }
    if (!isStudent) {
      notifyError('Only students can enroll in courses.');
      return false;
    }

    setEnrollingId(courseId);
    try {
      await enrollInCourse(courseId, getAuthHeaders());
      if (onSuccess) onSuccess(courseId);
      notifySuccess(`You're enrolled in "${courseTitle}"!`);
      return true;
    } catch (err) {
      notifyError(err.message || 'Enrollment failed. Please try again.');
      return false;
    } finally {
      setEnrollingId(null);
    }
  };

  return { enroll, enrollingId };
}
